/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';

export const DesktopBr = styled.br`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;
